export enum AgsIdentityType {
  Admin = 1,
  IIQAdmin,
  Orphan,
  Worker,
  NonWorker_Test,
  Worker_ODC,
  NonWorker,
  Generic_ExternalApplicationAccount,
  Generic_ActiveDirectory,
  Boneyard,
  ExternalApplicationAccount_ActiveDirectory,
}
